{
  "name": "eliorgroup-time-backoffice-webapp",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-prod": "ng build --configuration production",
    "build-dev": "ng build --configuration development",
    "build-uat": "ng build --configuration uat",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "openapi": "rimraf src/api && cross-env NODE_TLS_REJECT_UNAUTHORIZED=0  openapi-generator-cli generate -i ../EliorGroup.Time.Backoffice.WebApi/swagger.json -o src/app/backend -g typescript-angular --package-name ApiClient --additional-properties=ngVersion=17.3.0"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.0",
    "@angular/common": "^17.3.0",
    "@angular/compiler": "^17.3.0",
    "@angular/core": "^17.3.0",
    "@angular/forms": "^17.3.0",
    "@angular/platform-browser": "^17.3.12",
    "@angular/platform-browser-dynamic": "^17.3.0",
    "@angular/router": "^17.3.0",
    "@azure/msal-angular": "^3.1.0",
    "@azure/msal-browser": "^3.27.0",
    "@microsoft/signalr": "^8.0.7",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@tailwindcss/container-queries": "^0.1.1",
    "@tailwindcss/forms": "^0.5.7",
    "@tailwindcss/typography": "^0.5.14",
    "jwt-decode": "^4.0.0",
    "ng-zorro-antd": "^17.4.1",
    "rxjs": "~7.8.0",
    "tailwindcss": "^3.4.10",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.8",
    "@angular/cli": "^17.3.8",
    "@angular/compiler-cli": "^17.3.0",
    "@openapitools/openapi-generator-cli": "^2.7.0",
    "@types/jasmine": "~5.1.0",
    "@types/jwt-decode": "^2.2.1",
    "@types/node": "^22.5.5",
    "autoprefixer": "^10.4.20",
    "cross-env": "^7.0.3",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.4.41",
    "typescript": "~5.4.2"
  }
}
